import React from 'react'
import PropTypes from 'prop-types'

const CopyrightLabel = ({ className, text }) => {
  return (
    <p
      className={`
        ${className}
        font-regular text-14 leading-20
        text-ffffff bg-40484d opacity-80
        px-16 py-8
      `}
    >
      {`© ${text}`}
    </p>
  )
}

CopyrightLabel.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
}

CopyrightLabel.defaultProps = {
  className: '',
  text: 'Copyright',
}

export default CopyrightLabel
